export { default as GoogleSvg } from './google.svg';
export { default as LogoSymbolSvg } from './logo-symbol.svg';
export { default as LogoSvg } from './logo.svg';
